import {
  Action,
  ActionCreator
} from 'redux';
import { Tab } from '@iv/model/tabs.model';

/**
 * ThreadActions specifies _action creators_ (i.e. objects that describe
 * changes to the reducers) that are concerned with Threads and Messages
 */

export const LOAD_TABS = '[Tabs] Load Tabs';

export interface LoadTabsAction extends Action {
  tabs: any[];
}

export const loadTabs: ActionCreator<LoadTabsAction> = (tabArgs: any[]): LoadTabsAction => {
  const tabs: any = tabArgs.splice(0);
  return {
    type: LOAD_TABS,
    tabs: tabs
  };
};

export const ADD_TAB = '[Tabs] Add Tab';

export interface AddTabAction extends Action {
  tab: any;
}

export const addTab: ActionCreator<AddTabAction> = (tabArgs: any): AddTabAction => {
  const tab: any = Object.assign({}, tabArgs);
  return {
    type: ADD_TAB,
    tab: tab
  };
};

export const SELECT_TAB = '[Tabs] Select';

export interface SelectTabAction extends Action {
  tab: any;
}

export const selectTab: ActionCreator<SelectTabAction> = (tab) => ({
  type: SELECT_TAB,
  tab: tab
});

export const DELETE_TAB = '[Tabs] Delete tab';

export interface DeleteTabAction extends Action {
  tab: any;
}

export const deleteTab: ActionCreator<DeleteTabAction> = (tab) => ({
  type: DELETE_TAB,
  tab: tab
});

export const UPDATE_TAB_DATA = '[Tabs] Update tab data';

export interface UpdateTabDataAction extends Action {
  field: {
    name: string;
    value: any;
  };
}

export const updateTabData: ActionCreator<UpdateTabDataAction> = (field) => ({
  type: UPDATE_TAB_DATA,
  field
});

export const UPDATE_SERVICE_TAB_DATA = '[Tabs] Update service tab data';

export interface UpdateServiceTabDataAction extends Action {
  field: {
    name: string;
    value: any;
  };
}

export const updateServiceTabData: ActionCreator<UpdateServiceTabDataAction> = (field) => ({
  type: UPDATE_SERVICE_TAB_DATA,
  field: field
});
